<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 10:55:50
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Event\EventType\EventType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-04 17:44:02
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_eventType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-event-type')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.color="{ item }">
          <div style="max-width: 20px">
            <svg-icon
              size="24"
              :fill="item.color_code"
              iconClass="LabeledColour"
            />
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.event_type_name) }}
          </div>
          <div class="table-subtitle text--secondary">
            {{ $getCommonLangValue(item.event_type_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">{{
          $getCommonLangValue(item.event_type_abbr)
        }}</template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-event-type')"
            :viewBtn="hasBtn('view-admin-event-type')"
            :editBtn="hasBtn('edit-admin-event-type')"
            :title="$t('label_essweb_eventType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main></template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "EventType",
  computed: {},
  data() {
    return {
      search: "",
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_list_components_tools_colorLabel",
          value: "color",
          align: "start",
          width: 40,
          sortable: false,
        },
        {
          text: "label_essweb_eventType_list_eventTypeNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.event_type_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_eventType_list_eventTypeAbbrLabel",
          value: "abbr",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/event-type/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/event-type/edit/"
          : "/admin/event-type/detail/") + uuid
      );
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_event_type",
        url: "/event-type/delete-event-type-table/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventType_list_deleteEventTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
